// extracted by mini-css-extract-plugin
module.exports = {"tabs":"VerticalTabs_tabs__1QeIM","tabWrapper":"VerticalTabs_tabWrapper__1jdtw","tab":"VerticalTabs_tab__2vAl6","tabSelected":"VerticalTabs_tabSelected__K1yTE"};